<h1 class="page-title">Browse STLWater</h1>
<app-drafts-toggle-button [draftCount]="draftCount" [(showDrafts)]="showDraftsTab"></app-drafts-toggle-button>
<section class="widget" *ngIf="showDraftsTab">
    <div class="widget-body">
        <h4>Draft Applications</h4>
        <app-drafts-table [applicationType]="ASSISTANCE_APPLICATION_TYPE"></app-drafts-table>
    </div>
</section>
<section class="widget" [hidden]="showDraftsTab">
    <div class="widget-body">
        <div class="mt">
            <form novalidate>
                <div class="row">
                    <div class="col-md col-12">
                        <ul class="help-text-align">
                            <li><span>To enter a new Assistance Application, go to ‘Clients’ Menu on the left.</span></li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md col-12">
                        <!--Search String #-->
                        <label class="header-label">Search:</label>
                        <input class="search-text-input form-control"
                               type="text"
                               placeholder="Enter Keyword"
                               [ngModel]="searchValue"
                               [ngModelOptions]="{standalone: true}"
                               (ngModelChange)="setSearchValue($event)"/>
                    </div>
                    <div class="col-md col-12">
                        <!--Agency modal filter-->
                        <label class="header-label">Agency:</label>
                        <input class="agency-modal-input form-control"
                               type="text"
                               placeholder="Select agency to filter"
                               (click)="showAgencyModal()"
                               (keydown)="showAgencyModal()"
                               value="{{selectedAgencyName}}"
                               [disabled]="isDisabledAgency()"/>
                    </div>
                    <div class="col-md col-12 dropdown-menu-top" *ngIf="isAdmin">
                        <!--Region Admin-->
                        <label class="header-label">Region Admin Agency:</label>
                        <select name="" id="" class="form-select form-control" [formControl]="selectedManagementAgencyId">
                            <option value="">-- Select Region Admin Agency--</option>
                            <option *ngFor="let agency of regionAdminAgencies"
                                    [value]="agency.id">{{agency.agencyName}}</option>
                        </select>
                    </div>
                    <div class="col-md col-12 dropdown-menu-top">
                        <!--Status filter-->
                        <label class="header-label">Case Status:</label>
                        <select name="" id="" class="form-select form-control" [formControl]="appStatus">
                            <option value="">-- Filter By Status --</option>
                            <option *ngFor="let status of statuses"
                                    [value]="status.value">{{formatStatus(status.value)}}</option>
                        </select>
                    </div>

                    <div class="col-md col-12 dropdown-menu-top">
                        <!--Public/Private filter-->
                        <label class="header-label">Public/Internal:</label>
                        <select name="" id="" class="form-select form-control" [formControl]="appPublicPrivate">
                            <option value="">-- Filter By Public/Internal --</option>
                            <option *ngFor="let publicPrivate of publicOrPrivate"
                                    [value]="publicPrivate.value">{{publicPrivate.key}}</option>
                        </select>
                    </div>
                </div>
                <div class="row align-items-center mt-1">
                    <div class="col-md-8 col-sm-12">
                        <button class="btn btn-primary" (click)="searchAssistanceApplications()">Search</button>
                        <button class="btn btn-secondary ms-2" (click)="clearFilters()">Clear Filters</button>
                    </div>

                    <div class="col-md-4 col-sm-12 text-md-right text-sm-left mt-2 mt-md-0">
                        <button class="btn btn-primary"
                                (click)="exportAssistanceApplications()"
                                [disabled]="isExporting">
                            <span *ngIf="isExporting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            {{isExporting ? 'Downloading...' : 'Download CSV'}}
                        </button>
                    </div>
                </div>


            </form>
            <table-dynamic id="datatable-table" class="table table-striped table-hover"
                           [headers]="tableHeaders" [currentPage]="currentPage" [totalCount]="totalCount"
                           (headerClick)="sortCases($event)" (pageChanged)="setPage($event)"
                           (limitChange)="setLimit($event)">
                <tr *ngFor="let app of assistanceApplicationList?.items">
                    <td class="hidden-sm-down">{{app?.fundTypeName}}</td>
                    <td><a [routerLink]="['../client', app?.clientId]"><strong>{{
                            app?.clientLastName}}</strong></a></td>
                    <td class="hidden-sm-down">{{app?.clientFirstName}}</td>
                    <td class="hidden-sm-down">***-**-{{app?.clientLast4Ssn}}</td>
                    <td class="hidden-sm-down">{{app?.enteredDate | moment: 'L'}}</td>
                    <td>{{formatStatus(app?.status)}}</td>
                    <td class="hidden-sm-down">{{app?.agencyName}}</td>
                    <td><a [routerLink]="['../client', app?.clientId, 'assistance-applications', app?.id]"
                    ><strong>{{app?.totalNeed
                        | currency:'USD':'symbol':'1.2-2'}}</strong></a></td>
                </tr>
            </table-dynamic>
        </div>
    </div>
    <agency-box id="agencyListModal" #agencyListModal (onAgencySelected)="onAgencySelected($event)"></agency-box>
</section>

